import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "view",
  "use": "view-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol viewBox=\"0 0 12 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"view\">\n<path d=\"M6 0C3.5 0 1.365 1.555 0.5 3.75C1.365 5.945 3.5 7.5 6 7.5C8.5025 7.5 10.635 5.945 11.5 3.75C10.635 1.555 8.5025 0 6 0ZM6 6.25C4.62 6.25 3.5 5.13 3.5 3.75C3.5 2.37 4.62 1.25 6 1.25C7.38 1.25 8.5 2.37 8.5 3.75C8.5 5.13 7.38 6.25 6 6.25ZM6 2.25C5.1725 2.25 4.5 2.9225 4.5 3.75C4.5 4.5775 5.1725 5.25 6 5.25C6.8275 5.25 7.5 4.5775 7.5 3.75C7.5 2.9225 6.8275 2.25 6 2.25Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol